export const ENDPOINT_PLAYLIST_API = process.env.REACT_APP_ENDPOINT_PLAYLIST_API
export const ENDPOINT_SEARCH = `${process.env.REACT_APP_LVS_API}/v3/search/advanced?query=`
export const ENDPOINT_GROUPED_SEARCH = `${process.env.REACT_APP_LVS_API}/v3/search/advanced/grouped?query=`
export const ENDPOINT_ASSET = `${process.env.REACT_APP_LVS_API}/v3/asset/`
